import { render, staticRenderFns } from "./EditNameAndCategory.vue?vue&type=template&id=5bf8464e"
import script from "./EditNameAndCategory.vue?vue&type=script&lang=js"
export * from "./EditNameAndCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports